import P from "../../pages";
import { generateProfileElementObject, changeState } from "../../utilities";
import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import FormHeader from "./FormHeader";
import Redirector from "./Redirector";
import Alert from "./Alert";
import ButtonGroup from "./ButtonGroup";
import ProfileElementField from "./ProfileElementField";
import FormControl from "react-bootstrap/lib/FormControl";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import CustomFormGroup from "./CustomFormGroup";
import { pageValid, executeValidations } from "../../validator";

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      extraPhone: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "public",
        "extra_phone",
      ),
      extraEmails: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "public",
        "extra_emails",
      ),
      emergencyContactName: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "emergency_contact_details",
        "name",
      ),
      emergencyContactRelationship: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "emergency_contact_details",
        "relationship",
      ),
      emergencyContactAddress: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "emergency_contact_details",
        "address",
      ),
      emergencyContactPhone: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "emergency_contact_details",
        "phone",
      ),
      emergencyContactEmail: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "emergency_contact_details",
        "email",
      ),
    };

    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.skip = this.skip.bind(this);
  }

  componentWillMount() {
    executeValidations(this);
  }

  changeState = async (id, val) => {
    changeState(this, id, val);
  };

  back(e) {
    if (e) e.preventDefault();
    this.props.onGoBack();
  }

  skip(e) {
    if (e) e.preventDefault();
    this.props.onSkipSubmit();
  }

  submit(e) {
    if (e) e.preventDefault();

    this.props.onHostProfileSubmit({
      public: {
        extra_phone: this.state.extraPhone.val,
        extra_emails: this.state.extraEmails.val,
      },
      lifestyle: {
        emergency_contact_details: {
          name: this.state.emergencyContactName.val,
          relationship: this.state.emergencyContactRelationship.val,
          address: this.state.emergencyContactAddress.val,
          phone: this.state.emergencyContactPhone.val,
          email: this.state.emergencyContactEmail.val,
        },
      },
    });
  }

  render() {
    const thisPage = P.CONTACT_PAGE;
    const contactContent = this.props.content?.pages?.contact || {};
    const page = this.props.page;

    return (
      <div id={page} className="profile">
        <Redirector this_page={thisPage} page={page} />
        <form onSubmit={this.submit}>
          <FormHeader title={contactContent.title} />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.extraEmails.valid}>
                <ControlLabel htmlFor="extraEmails">Extra Email Addresses</ControlLabel>
                <FormControl
                  id="extraEmails"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.extraEmails.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="extra_emails"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.extraPhone.valid}>
                <ControlLabel htmlFor="extraPhone">Extra Phone Number</ControlLabel>
                <FormControl
                  id="extraPhone"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.extraPhone.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="extra_phone"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.emergencyContactName.valid}>
                <ControlLabel htmlFor="emergencyContactName">Emergency Contact Name</ControlLabel>
                <FormControl
                  id="emergencyContactName"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.emergencyContactName.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="emergency_contact_details"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.emergencyContactRelationship.valid}>
                <ControlLabel htmlFor="emergencyContactRelationship">
                  Emergency Contact Relationship
                </ControlLabel>
                <FormControl
                  id="emergencyContactRelationship"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.emergencyContactRelationship.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="emergency_contact_details"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.emergencyContactAddress.valid}>
                <ControlLabel htmlFor="emergencyContactAddress">Emergency Contact Address</ControlLabel>
                <FormControl
                  id="emergencyContactAddress"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.emergencyContactAddress.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="emergency_contact_details"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.emergencyContactPhone.valid}>
                <ControlLabel htmlFor="emergencyContactPhone">Emergency Contact Phone</ControlLabel>
                <FormControl
                  id="emergencyContactPhone"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.emergencyContactPhone.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="emergency_contact_details"
          />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.emergencyContactEmail.valid}>
                <ControlLabel htmlFor="emergencyContactEmail">Emergency Contact Email</ControlLabel>
                <FormControl
                  id="emergencyContactEmail"
                  type="text"
                  componentClass="input"
                  defaultValue={this.state.emergencyContactEmail.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="emergency_contact_details"
          />

          <Alert alert={contactContent.body} />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            skipFunc={this.skip}
            intl={this.props.intl}
            page={thisPage}
            user={this.props.user}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
          />
        </form>
      </div>
    );
  }
}

Contact.propTypes = {
  onHostProfileSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  profileElements: PropTypes.array,
  activeProfileElements: PropTypes.array,
  requiredFields: PropTypes.object,
  user: PropTypes.object,
};

export default injectIntl(Contact);
